import { useCallback, useState } from 'react';
import { Button } from 'antd';
import { RightArrowIcon } from 'svgIcon';
import cartIcon from "assets/images/cartIcon.svg";
import { onStoreData } from 'utils/checkout';
import { EcommerceFlow, shortenValue, toastMessage, useGlobalMerchant } from 'utils/helper';
import BasketExclusiveComponent from 'components/Basket/BasketExclusiveComponent';
import DrawerComponent from 'components/FormComponent/DrawerComponent'
import { useBasket } from 'containers/POSContainer/constant';

const ECEHeaderComponent = ({
    renderLogoIcon,
    showShippingLayout,
    setShowSideBasket,
    showSideBasket,
    setShowShippingLayout,
    ecommerceContent,
    googleReCaptchaProps,
    isEndsWithSlash,
    pagesContent
}: any) => {
    const itemlist = useBasket();
    const { globalMerchantId, globalMerchantCurrency, setPaymentIframeURL } = useGlobalMerchant();
    const [onBtnLoader, setOnBtnLoader] = useState(false);

    const totalAmounts = itemlist && itemlist.itemList.map((item: any) => item.qty * item.product.price);
    const grandTotal = totalAmounts.reduce((acc: any, amount: any) => acc + amount, 0);
    const length = itemlist.itemList.length; // Define length here

    const onErrorCall = (getErrorMessage: any) => {
        if (getErrorMessage == "Failed reCAPTCHA verification") {
            getToken();
        } else {
            toastMessage(getErrorMessage);
            setOnBtnLoader(false);
        }
    }

    const getToken = useCallback(async () => {
        if (googleReCaptchaProps && googleReCaptchaProps.executeRecaptcha) {
            try {
                const _token = await googleReCaptchaProps.executeRecaptcha("homepage");
                onStoreData(itemlist, grandTotal, globalMerchantId, globalMerchantCurrency, EcommerceFlow, setOnBtnLoader, _token, onErrorCall, setPaymentIframeURL);
            } catch (error) { console.error('Error while executing recaptcha:', error); }
        } else { console.error('googleReCaptchaProps.executeRecaptcha is not available.'); }
    }, [googleReCaptchaProps]);

    const onCheckout = () => {
        const getPathname = window.location.pathname;
        if (getPathname === "/order") {
            toastMessage("Coming Soon");
        } else {
            if (grandTotal !== 0 && Object.keys(ecommerceContent).length > 0) {
                setOnBtnLoader(true);
                if (ecommerceContent.shipping_address == 1) {
                    setShowShippingLayout(true);
                    setShowSideBasket(false);
                } else if (ecommerceContent.shipping_address == 0) {
                    getToken();
                }
            }
        }
    }

    return (
        <div className="headerWrapper dFlex alignCenter justifyBetween">
            <div className="logo">{renderLogoIcon()}</div>
            {!isEndsWithSlash && (
                <div
                    className={!showShippingLayout ? length > 0 ? "basket-icon active" : "basket-icon" : "disable"}
                    onClick={() => !showShippingLayout && setShowSideBasket(true)}
                >
                    <img src={cartIcon} className="cursorPointer" alt="" />
                    <span className="ePNum">{length > 0 && length}</span>
                </div>
            )}
            <DrawerComponent
                size={600}
                title={"Your Cart"}
                extraClass={"exclusiveCart"}
                isClosable={true}
                footer={
                    <div className="drawerFooter dFlex alignCenter justifyBetween">
                        <div className="left">
                            <p className="eNmText">Total Amount</p>
                            <p className="eXLgText">{shortenValue(grandTotal)} {globalMerchantCurrency}</p>
                        </div>
                        <div className="right">
                            <Button
                                className="eBtn"
                                type="primary"
                                onClick={onCheckout}
                                disabled={grandTotal === 0}
                            >
                                {onBtnLoader ? "Loading..." : "Proceed"}<span><RightArrowIcon /></span>
                            </Button>
                        </div>
                    </div>
                }
                onOpen={showSideBasket}
                onClose={() => setShowSideBasket(false)}
            >
                <BasketExclusiveComponent />
            </DrawerComponent>
        </div>
    )
}

export default ECEHeaderComponent